import { Router, ScreenBase } from "@frui.ts/screens";
import { watchBusy } from "@frui.ts/screens/dist";
import BusyWatcher from "@frui.ts/screens/dist/structure/busyWatcher";
import { action, computed, observable } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import download from "downloadjs";
import TurnoverRepository from "../../../repositories/turnoverRepository";
import MonthOptionsService from "../../../services/monthOptionsService";
import Month from "../../../entities/month";

const navigationName = "turnout-checkouts";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
})
export default class TurnoutCheckoutsViewModel extends ScreenBase {
  @observable selectedDate?: Date;
  @observable busyWatcher = new BusyWatcher();

  @computed
  get selectedMonth() {
    if (this.selectedDate) {
      return new Month(this.selectedDate);
    }
    return undefined;
  }

  constructor(
    private turnoverRepository: TurnoverRepository,
    private localizationService: LocalizationService,
    private monthOptionsService: MonthOptionsService
  ) {
    super();
    this.navigationName = navigationName;
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @computed
  get months() {
    return this.monthOptionsService.startOfMonthOptions;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `turnoutCheckouts.${code}`, size);
  }

  @computed
  get downloadDisabled() {
    return this.busyWatcher.isBusy || !this.selectedMonth;
  }

  @action.bound
  @watchBusy
  async onDownloadClick() {
    if (!this.selectedMonth) {
      return;
    }
    const fileName = `${this.selectedMonth.name}.zip`;

    try {
      const response = await this.turnoverRepository.download(this.selectedMonth);
      download(response, fileName);
    } catch (e) {
      console.error(e);
    }
  }
}
